import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import moment from 'moment';
export const ASSESSMENT_RETAKE_TIME = 1;

/**
 * Check if a user is currently doing an assessment.
 *
 * This uses the AssessmentIndex collection
 *
 * TODO: Resolve `ASSESSMENT_RETAKE_TIME` from the backend
 * @param patientInfo
 * @returns
 */
export function isLastPatientAssessmentExpired(
  patientInfo: Pick<PatientInfoState, 'assessmentOverview'>
) {
  // Sort the data in descending order by date
  const lastAssessmentDate = patientInfo.assessmentOverview?.lastAssessmentDate;
  if (lastAssessmentDate === undefined || lastAssessmentDate === null) {
    return true;
  }

  /**
   * Return true if the user has no assessments, or if the last assessment was more than ASSESSMENT_RETAKE_TIME ago
   */
  return moment(lastAssessmentDate).isBefore(
    moment().subtract(ASSESSMENT_RETAKE_TIME, 'days')
  );
}
